export const ErrorPage = () => {
  return <div>Error</div>;
};
